import { CloudOff, Refresh } from "@mui/icons-material";
import { Button } from "@mui/material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";

interface SessionCheckFailedPageProps {
  onRetry: () => void;
}

/**
 * Проверить сессию не удалось по технической причине: сеть, таймаут, ошибка сервера.
 * На вход не уводим — это не отсутствие сессии, повтор делает свежий запрос.
 */
export const SessionCheckFailedPage = ({
  onRetry,
}: SessionCheckFailedPageProps): JSX.Element => (
  <InfoPageLayout>
    <InfoPage
      title="Не удалось проверить вход"
      message="Проверьте подключение к сети и повторите попытку"
      illustration={<InfoPageIllustration icon={CloudOff} />}
      actions={
        <Button
          variant="contained"
          color="primary"
          startIcon={<Refresh />}
          onClick={onRetry}
        >
          Повторить
        </Button>
      }
    />
  </InfoPageLayout>
);
